import PropTypes from 'prop-types';
import { useRef } from 'react';

import CountDown from './CountDown/CountDown';
import styles from './Slider.module.css';
import SliderViewer from './SliderViewer/SliderViewer';
import TableViewer from './TableViewer/TableViewer';

const Slider = ({ data, max_width = false }) => {
  const sliderRef = useRef(null);
  const stepWidthPercent = 97;

  const handleNextSlide = () => {
    if (sliderRef.current) {
      const stepWidth = (sliderRef.current.clientWidth * stepWidthPercent) / 100;
      sliderRef.current.scrollBy({
        left: -stepWidth,
        behavior: 'smooth'
      });
    }
  };

  const handlePrevSlide = () => {
    if (sliderRef.current) {
      const stepWidth = (sliderRef.current.clientWidth * stepWidthPercent) / 100;
      sliderRef.current.scrollBy({
        left: stepWidth,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div
      className={`${styles.SliderContainer} ${max_width ? styles.MaxWidth : ''}`}
      style={{
        backgroundImage: `linear-gradient(to right, ${data.background_color_left}, ${data.background_color_right})`
      }}>
      {data?.title ? (
        <div className={styles.SliderHeader}>
          {data.title ? (
            <div className={styles.Subtitle}>
              <svg
                fill="none"
                height="10"
                viewBox="0 0 7 10"
                width="7"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.610394 5.52255C0.347422 5.32631 0.34155 4.93425 0.598527 4.73023L5.96564 0.469115C6.2906 0.211121 6.77026 0.438346 6.77648 0.853219L6.90168 9.21281C6.90789 9.62768 6.43524 9.86917 6.10271 9.62102L0.610394 5.52255Z"
                  fill={data.title_color}
                />
              </svg>
              <span style={{ color: data.title_color }}>{data?.title}</span>
            </div>
          ) : null}
          <CountDown
            code={data.design.code}
            color={data.design.color}
            ended_at={data.ended_at}
            is_active={data.counter_is_active}
            now={data.now}
            position={data.design.position}
            started_at={data.started_at}
          />
        </div>
      ) : null}
      {data.products.length >= 3 && !data.is_table_view ? (
        <div className={styles.NavigationButtons}>
          <button
            className={styles.LeftButton}
            onClick={handlePrevSlide}
            shape="circle"
            type="button">
            {' '}
            &lsaquo;{' '}
          </button>
          <button
            className={styles.RightButton}
            onClick={handleNextSlide}
            shape="circle"
            type="button">
            {' '}
            &rsaquo;
          </button>
        </div>
      ) : null}
      {!data.is_table_view ? (
        <SliderViewer data={data} sliderRef={sliderRef} />
      ) : (
        <TableViewer data={data} />
      )}
    </div>
  );
};

Slider.propTypes = {
  data: PropTypes.array
};

export default Slider;
